import React, { useRef, useState }  from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { clearAll } from 'src/redux/registrant';
import Form from 'components/Form/Form';
import vw from 'src/styles/utils';
import media from 'src/styles/media';
import Loading from 'components/Loading';
import Helmet from 'react-helmet';

const PCForm = () => {
  const { person, email } = useSelector((state) => state.registrant);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  
  return (
    <Root>
     <Helmet meta={[
        {
          name: 'robots',
          content: 'noindex,nofollow',
        }
		]}
    />
      <Logo src={require('src/assets/images/logo.svg')} alt="logo" />

      <Title>
        <h1>New Registration</h1>
        <h3>The email you have entered is not in our database. Please complete the following to complete your registration.</h3>
       </Title>
      
      
     

      <Form email={email} formType="PC" />
      
      
     
    </Root>
  );
};

const Root = styled.main`

${vw('padding-top', 42, 75, 122)}
  ${vw('padding-bottom', 66, 99, 105)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 200)}

`;


const Logo = styled.img`
  position:relative;
  ${vw('top', -350, 0, 0)}
  ${vw('left', 0, 0, 0)}
  ${vw('width', 80, 126)}
  ${vw('height', 0, 221)}
  @media ${media.desktop} {
    position:fixed;
    left:unset;
    ${vw('right', 25, 0, 100)}
  }
`

const Title = styled.div`
 /* background-image: url(${require('src/assets/images/hero-extened.jpg')});
 background-size: cover;
  
  width:100vw;
  height:100vh; */
 
  h1{
    font-family: Gotham Black;
  ${vw('font-size', 20, 50)}
 ${vw('padding-bottom', 10, 75, 20)}
}
h3{
  font-family: Gotham Medium;
  font-weight: 500;
  ${vw('font-size', 14, 25)}
 ${vw('padding-bottom', 30, 75, 40)}
 ${vw('padding-right', 0, 60, 200)}
}
p{
    font-family: Big Caslon;
   font-style: normal;
   font-weight: normal;
   color: #000000;
   text-transform: none;
   ${vw('font-size', 14, 20)}
   ${vw('line-height', 22, 32)}
 

}
 span {
   color: #DE5647;
 }
 
  `


export default PCForm;
